// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f219b6ec","455":"94c8737a","977":"5981c247"}[chunkId] + ".chunk.js";
};